module.exports = __webpack_public_path__ + "img/bsAttrCard_icon_01.2c00d888.png";